export default "__VITE_ASSET__b4326419__"